var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup71({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.724 60C111.724 31.4336 88.5664 8.27588 60 8.27588C31.4335 8.27588 8.27582 31.4336 8.27582 60C8.27582 88.5665 31.4335 111.724 60 111.724C88.5664 111.724 111.724 88.5665 111.724 60ZM88.6952 60.4225C88.6952 44.852 76.0728 32.2296 60.5023 32.2296C44.9318 32.2296 32.3094 44.852 32.3094 60.4225C32.3094 75.993 44.9318 88.6154 60.5023 88.6154C76.0728 88.6154 88.6952 75.993 88.6952 60.4225Z",
    fill: "#FCE400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120 60C120 26.8629 93.1371 -3.68948e-06 60 -2.37681e-06C26.8629 0 -4.49231e-06 26.8629 -2.894e-06 60C0 93.1371 26.8629 120 60 120C93.1371 120 120 93.1371 120 60ZM74.4828 60C74.4828 52.0014 67.9986 45.5172 60 45.5172C52.0014 45.5172 45.5172 52.0014 45.5172 60C45.5172 67.9986 52.0014 74.4828 60 74.4828C67.9986 74.4828 74.4828 67.9986 74.4828 60Z",
    fill: "#FCE400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup71);
export default __webpack_public_path__ + "static/media/Group 71.0a20443d8222d39c1abf97f3c95250d7.svg";
export { ForwardRef as ReactComponent };